














import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { State, Mutation, Action } from 'vuex-class'

import isMobile from 'ismobilejs'

import Header1 from '../../html-components-type-2-application-specific/application-specific-type-1-introduction/introduction-type-1-header/header-1.vue'
import Footer1 from '../../html-components-type-2-application-specific/application-specific-type-1-introduction/introduction-type-2-footer/footer-1.vue'
import UserInterface4NotificationList from '../basic-type-4-user-interface/user-interface-4-notification-list.vue'

import { ServiceAccount } from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-2-data-structures/data-structures-1-service-account/service-account-1'

import {
  TOGGLE_IS_MOBILE_DEVICE,
  ADD_NOTIFICATION
} from '../../../../service-for-game-evaluation-loop/game-evaluation-loop-type-2-support/support-type-2-random/random-type-2-store/service-for-store-support-vectors/store-support-vectors-type-2-algorithms/algorithms-type-1-mutations/mutations-1-general'

import {
  Notification,
  NOTIFICATION_TYPE_TRANSACTION,
  HTML_ITEM_ID_CHIP
} from '../../../../service-for-game-evaluation-loop/game-evaluation-loop-type-2-support/support-type-2-random/random-type-2-store/service-for-store-support-vectors/store-support-vectors-type-1-data-structures/data-structures-1-root-state'

import {
  RECEIVED_TRANSACTION_DATA_TABLE
} from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-3-digital-currency-transaction/digital-currency-transaction-type-3-constants/constants-3-transaction-account-statistics'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

const namespace = 'digitalCurrency'

@Component({
  components: {
    Header1,
    Footer1,
    UserInterface4NotificationList
  }
})
class App1 extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean
  @State('serviceAccount') serviceAccount?: ServiceAccount

  @Mutation(TOGGLE_IS_MOBILE_DEVICE) TOGGLE_IS_MOBILE_DEVICE?: any
  @Mutation(ADD_NOTIFICATION) ADD_NOTIFICATION?: any

  @Action('initializeServiceAccount') initializeServiceAccount?: any
  @Action('addEventListenerToDigitalCurrencyAccountTransactionStatistics', { namespace }) addEventListenerToDigitalCurrencyAccountTransactionStatistics?: any
  @Action('removeEventListenerFromDigitalCurrencyAccountTransactionStatistics', { namespace }) removeEventListenerFromDigitalCurrencyAccountTransactionStatistics?: any
  @Action('getDigitalCurrencyTransactionById', { namespace }) getDigitalCurrencyTransactionById?: any
  @Action('getDigitalCurrencyAccountById', { namespace }) getDigitalCurrencyAccountById?: any

  eventListenerActiveDigitalCurrencyAccountId: string = ''
  eventListenerIdMap: { [eventTypeId: string]: string } = {}

  @Watch('serviceAccount') async onUpdateServiceAccount (newValue: ServiceAccount, oldValue: ServiceAccount) {

    // Remove Event Listeners
    if (newValue && oldValue && (newValue.activeDigitalCurrencyAccountId !== oldValue.activeDigitalCurrencyAccountId) && this.eventListenerActiveDigitalCurrencyAccountId) {
      await this.removeEventListenerListFromDigitalCurrencyAccount()
      this.eventListenerActiveDigitalCurrencyAccountId = ''
    }

    // Add Event Listener
    if (newValue && (newValue.activeDigitalCurrencyAccountId) && !this.eventListenerActiveDigitalCurrencyAccountId) {
      this.eventListenerActiveDigitalCurrencyAccountId = newValue.activeDigitalCurrencyAccountId
      await this.addEventListenerListToDigitalCurrencyAccount()
    }
  }

  async addEventListenerListToDigitalCurrencyAccount () {
    this.eventListenerIdMap[RECEIVED_TRANSACTION_DATA_TABLE] = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: RECEIVED_TRANSACTION_DATA_TABLE,
      eventListenerCallbackFunction: async (data: any) => {
        const transactionIdList = data.dataList || []
        for (let i = 0; i < transactionIdList.length; i++) {
          const transactionId = transactionIdList[i]
          const digitalCurrencyTransaction = await this.getDigitalCurrencyTransactionById(transactionId)
          const digitalCurrencyAccountTransactionSender = await this.getDigitalCurrencyAccountById(digitalCurrencyTransaction.accountSenderId)
          const digitalCurrencyTransactionAmount = digitalCurrencyTransaction ? `${digitalCurrencyTransaction.transactionCurrencyAmount} ${projectVariables.digitalCurrencyName} ${digitalCurrencyTransaction.isRecurringTransaction ? `every ${digitalCurrencyTransaction.originalTimeNumberUntilNextRecurrence} ${digitalCurrencyTransaction.originalTimeScaleUntilNextRecurrence}` : ''}` : ''
          this.ADD_NOTIFICATION({
            notificationId: `${Math.random()}`,
            notificationType: NOTIFICATION_TYPE_TRANSACTION,
            notificationIconImageUrl: 'description',
            notificationMessage: `New Transaction Received from {{html1}} of {{html2}}`,
            notificationMoreInformationUrl: `${location.origin}/transaction/${digitalCurrencyTransaction.transactionId}`,
            notificationMessageHtmlItemList: [{
              htmlItemId: HTML_ITEM_ID_CHIP,
              showRainbowBackground: true,
              iconImageUrl: digitalCurrencyAccountTransactionSender.accountProfilePictureUrl,
              text: digitalCurrencyAccountTransactionSender.accountName
            }, {
              htmlItemId: HTML_ITEM_ID_CHIP,
              iconImageUrl: projectVariables.digitalCurrencySymbolImageIconUrl,
              text: digitalCurrencyTransactionAmount
            }],
            notificationDate: new Date(digitalCurrencyTransaction.dateTransactionCreated)
          } as Notification)
        }
      },
      statisticsOptions: { digitalCurrencyAccountId: this.eventListenerActiveDigitalCurrencyAccountId }
    })
  }

  async removeEventListenerListFromDigitalCurrencyAccount () {
    await this.removeEventListenerFromDigitalCurrencyAccountTransactionStatistics({
      statisticsType: RECEIVED_TRANSACTION_DATA_TABLE,
      eventListenerId: this.eventListenerIdMap[RECEIVED_TRANSACTION_DATA_TABLE],
      statisticsOptions: { digitalCurrencyAccountId: this.eventListenerActiveDigitalCurrencyAccountId }
    })
    delete this.eventListenerIdMap[RECEIVED_TRANSACTION_DATA_TABLE]
  }

  async mounted () {
    this.watchMobileSettings()

    // Initialize Service Account
    await this.initializeServiceAccount()
  }

  async destroyed () {
    await this.removeEventListenerListFromDigitalCurrencyAccount()
  }

  watchMobileSettings () {
    this.TOGGLE_IS_MOBILE_DEVICE(window.innerWidth < 600 || isMobile().any)

    window.addEventListener('resize', (_event) => {
      // if windows size < 600px, let's say mobile, otherwise not
      const isMobileDevice = window.innerWidth < 600 || isMobile().any

      this.TOGGLE_IS_MOBILE_DEVICE(isMobileDevice)

      if (isMobileDevice) {
        //
      }
    })
  }
}

export default App1
